export default __webpack_public_path__ + "static/media/gnd_en_star_b1.6cb78216.mp3";